import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import queryString from "query-string";
//import SignatureCanvas from "react-signature-canvas";
import $ from "jquery";
import { AJAROOT } from "@/common/gdata/global.js";
//import MySignatureCanvas from "@/jscript/myCanve.js";
import {
  checkUserLogin,
  IsPC,
  MyToast,
  MyToastShow,
  getDateFromPeriodno,
} from "@/jscript/common.js";
import axios from "axios";
import "@/css/user.css";

//import DatePicker from "react-datepicker";

const LCss = {
  agree: {
    padding: "15px",
  },
  signdiv: {
    verticalAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
  },
  signcave: {
    height: "52px",
    lineHeight: "52px",
    width: "202px",

    border: "1px solid #ccc",
    position: "relative",
    float: "left",
    textAlign: "left",
  },
  canve: {
    background: "#fff",
    position: "absolute",
    top: 0,
    left: 0,
  },
  radio: {
    width: "18px",
    height: "18px",
    marginLeft: "10px",
    marginRight: "3px",
  },
  conditioncheck: {
    display: "flex",

    alignContent: "center",
    paddingLeft: "5px",
    Height: "25px",
    lineHeight: "25px",
  },
  conditiondiv: {
    width: "100%",
    paddingLeft: "5px",
    fontWeight: "bold",
    height: "30px",
    lineHeight: "30px",
  },
  checkout: {
    width: "18px",
    height: "18px",
    marginRight: "5px",
  },
  field: {
    display: "inline-block",
    paddingLeft: "10px",
    paddingRight: "10px",

    borderBottom: "1px solid #000",
    marginRight: "18px",
    marginLeft: "5px",
  },
};
class User extends Component {
  constructor(props) {
    super(props);

    this.state = {
      //  myu: "",

      title: "",
      error: "",
      editid: "",
      bookid: "",
      customer: "",
      periodno: "",
      fromtime: "",
      totime: "",
      minutes: 0,
      price: 0,
      employeename: "",

      limititation: "",
      goal: "",
      focus: "",
      discussed: "",
      received: "",
      frequency: "",
      duratiuon: "",
      areas: [],
      performed: "",
      result: "",
      schedule: "",
      referral: "",
      antiresponse: "",
      recommended: "",
      contraindications: "",

      postresult: "",
      mytoast: {
        show: false,
      },
      isprint: false,
    };
  }

  render() {
    const { myusername } = this.props;
    const IsMobile = !IsPC();
    let checkstatus = checkUserLogin(this.props, myusername);

    if (checkstatus != "") return checkstatus;
    //var zsxm = this.state.zsxm;
    // if (zsxm === "") zsxm = this.state.myusername;

    return (
      <div
        className="container wrap"
        style={{ height: "100%", paddingBottom: "90px" }}
      >
        <div className="row " style={{ height: "55px", lineHeight: "55px" }}>
          <div
            className="col-xs-2 col-sm-2 col-md-2 col-lg-2"
            onClick={() => {
              this.back();
            }}
          >
            {!this.state.isprint && (
              <span className="iconfont fanhui">&#xe625;</span>
            )}
          </div>
          <div
            className="col-xs-8 col-sm-8 col-md-8 col-lg-8 textcenter "
            style={{ fontSize: "19px", fontWeight: "bolder" }}
          >
            {!this.state.isprint ? this.state.title : ""}
          </div>
          <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
            {!this.state.isprint ? (
              <a
                onClick={() =>
                  this.print(
                    "/user/form/treatplan?bookid=" +
                      this.state.bookid +
                      "&print=1"
                  )
                }
              >
                 {!IsMobile?"Print":""}
              </a>
            ) : (
              <input
                style={{ height: "35px", lineHeight: "35px" }}
                type="button"
                value="Print"
                onClick={() =>
                  this.printPage(
                    "/user/form/treatplan?bookid=" +
                      this.state.bookid +
                      "&print=1"
                  )
                }
              ></input>
            )}
          </div>
        </div>
        <div className="PageNext" id="content">
          {this.state.isprint && (
            <div className="printtitle">{this.state.title}</div>
          )}
          <div className="row" style={{ paddingTop: "10px" }}>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 form">
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 textleft">
                  Treatement Plan for:
                  <span
                    style={Object.assign({}, LCss.field, {
                      width: "150px",
                    })}
                  >
                    {this.state.customer}
                  </span>{" "}
                  Date:
                  <span
                    style={Object.assign({}, LCss.field, {
                      width: "150px",
                    })}
                  >
                    {getDateFromPeriodno(this.state.periodno)}
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 textleft">
                  Limitations of activities of daily living:
                  <span
                    style={Object.assign({}, LCss.field, {
                      borderBottom: "0px",
                    })}
                  >
                    <input
                      className="printField"
                      style={{ width: "200px" }}
                      value={this.state.limititation}
                      onChange={(ref) => this.changeField(ref, "limititation")}
                    />
                  </span>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 textleft">
                  Treatment plan discussed with Client:
                  <span
                    style={Object.assign({}, LCss.field, {
                      borderBottom: "0px",
                    })}
                  >
                    <input
                      type="radio"
                      name="discussed"
                      value="Y"
                      onChange={(ref) => this.setCheck(ref, "discussed")}
                      checked={this.state.discussed == "Y" ? true : false}
                      style={{
                        width: "18px",
                        height: "18px",
                      }}
                    ></input>
                    {"Yes "}
                    <input
                      type="radio"
                      name="discussed"
                      value="N"
                      onChange={(ref) => this.setCheck(ref, "discussed")}
                      checked={this.state.discussed == "N" ? true : false}
                      style={{
                        width: "18px",
                        height: "18px",
                      }}
                    ></input>
                    {"No"}
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 textleft">
                  Clients Goal / Treatment Goal:
                  <span
                    style={Object.assign({}, LCss.field, {
                      borderBottom: "0px",
                    })}
                  >
                    <input
                      className="printField"
                      style={{ width: "200px" }}
                      value={this.state.goal}
                      onChange={(ref) => this.changeField(ref, "goal")}
                    />
                  </span>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 textleft">
                  Received informed consent for treatment:
                  <span
                    style={Object.assign({}, LCss.field, {
                      borderBottom: "0px",
                    })}
                  >
                    <input
                      type="radio"
                      name="received"
                      value="Y"
                      onChange={(ref) => this.setCheck(ref, "received")}
                      checked={this.state.received == "Y" ? true : false}
                      style={{
                        width: "18px",
                        height: "18px",
                      }}
                    ></input>
                    {"Yes "}
                    <input
                      type="radio"
                      name="received"
                      value="N"
                      onChange={(ref) => this.setCheck(ref, "received")}
                      checked={this.state.received == "N" ? true : false}
                      style={{
                        width: "18px",
                        height: "18px",
                      }}
                    ></input>
                    {"No"}
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 textleft">
                  Type / Focus of treatment:
                  <span
                    style={Object.assign({}, LCss.field, {
                      borderBottom: "0px",
                    })}
                  >
                    <input
                      className="printField"
                      style={{ width: "360px" }}
                      value={this.state.focus}
                      onChange={(ref) => this.changeField(ref, "focus")}
                    />
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 textleft">
                  Frequency:
                  <span
                    style={Object.assign({}, LCss.field, {
                      borderBottom: "0px",
                    })}
                  >
                    <input
                      className="printField"
                      style={{ width: "200px" }}
                      value={this.state.frequency}
                      onChange={(ref) => this.changeField(ref, "frequency")}
                    />
                  </span>
                </div>
                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 textleft">
                  Duration:
                  <span
                    style={Object.assign({}, LCss.field, {
                      borderBottom: "0px",
                    })}
                  >
                    <input
                      className="printField"
                      style={{ width: "200px" }}
                      value={this.state.duratiuon}
                      onChange={(ref) => this.changeField(ref, "duratiuon")}
                    />
                  </span>
                </div>
              </div>
              <div className="row" style={{ height: "25px" }}>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 textleft">
                  <span style={{ fontWeight: "bold" }}>
                    Areas to be treated:
                  </span>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 textleft">
                  {this.state.areas.map((item, index) => {
                    let q = "";
                    let haveq = false;
                    if (typeof item.q != "undefined") {
                      haveq = true;
                      q = item.q;
                    }
                    let width = "160px";
                    if (haveq) width = "320px";
                    return (
                      <div
                        key={"acer" + index}
                        style={{
                          display: "flex",
                          width: width,
                          float: "left",
                          padding: "5px",
                        }}
                      >
                        <input
                          type="checkbox"
                          name="ser"
                          value="Y"
                          onChange={(ref) =>
                            this.changeField2(ref, index, "areas")
                          }
                          checked={item.c == "Y" ? true : false}
                          style={{
                            width: "18px",
                            height: "18px",
                            marginRight: "3px",
                          }}
                        ></input>
                        {item.name}

                        {haveq && (
                          <div
                            style={{
                              paddingLeft: "5px",
                            }}
                          >
                            , {q}{" "}
                            <input
                              className="printField"
                              style={{ height: "25px", with: "100px" }}
                              value={item.a}
                              onChange={(ref) =>
                                this.changeField3(ref, index, "areas")
                              }
                            />
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 textleft">
                  Accessments Performed:
                  <span
                    style={Object.assign({}, LCss.field, {
                      borderBottom: "0px",
                    })}
                  >
                    <input
                      className="printField"
                      style={{ width: "200px" }}
                      value={this.state.performed}
                      onChange={(ref) => this.changeField(ref, "performed")}
                    />
                  </span>
                </div>
                      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 textleft">
                  Anticipated Progression of Responses:
                  <span
                    style={Object.assign({}, LCss.field, {
                      borderBottom: "0px",
                    })}
                  >
                    <input
                      className="printField"
                      style={{ width: "200px" }}
                      value={this.state.antiresponse}
                      onChange={(ref) => this.changeField(ref, "antiresponse")}
                    />
                  </span>
                </div>
              </div>

              <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 textleft">
                  Results of Assessments:
                  <span
                    style={Object.assign({}, LCss.field, {
                      borderBottom: "0px",
                    })}
                  >
                    <input
                      className="printField"
                      style={{ width: "200px" }}
                      value={this.state.result}
                      onChange={(ref) => this.changeField(ref, "result")}
                    />
                  </span>
                </div>
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 textleft">
                  Remedial exercises / Hydrotherapy recommended:
                  <span
                    style={Object.assign({}, LCss.field, {
                      borderBottom: "0px",
                    })}
                  >
                    <input
                      className="printField"
                      style={{ width: "200px" }}
                      value={this.state.recommended}
                      onChange={(ref) => this.changeField(ref, "recommended")}
                    />
                  </span>
                </div>
              </div>

              <div className="row">
                 <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 textleft">
                  Reassessment schedule:
                  <span
                    style={Object.assign({}, LCss.field, {
                      borderBottom: "0px",
                    })}
                  >
                    <input
                      className="printField"
                      style={{ width: "200px" }}
                      value={this.state.schedule}
                      onChange={(ref) => this.changeField(ref, "schedule")}
                    />
                  </span>
                </div>
             <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 textleft">
                  Contraindications / Risks:
                  <span
                    style={Object.assign({}, LCss.field, {
                      borderBottom: "0px",
                    })}
                  >
                    <input
                      className="printField"
                      style={{ width: "200px" }}
                      value={this.state.contraindications}
                      onChange={(ref) =>
                        this.changeField(ref, "contraindications")
                      }
                    />
                  </span>
                </div>
              </div>

              <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 textleft">
                  Referrals:
                  <span
                    style={Object.assign({}, LCss.field, {
                      borderBottom: "0px",
                    })}
                  >
                    <input
                      className="printField"
                      style={{ width: "200px" }}
                      value={this.state.referral}
                      onChange={(ref) => this.changeField(ref, "referral")}
                    />
                  </span>
                </div>
                      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 textleft"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="row" style={{ paddingTop: "25px" }}>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 textcenter">
            <button className="submit" onClick={() => this.submit()}>
              Submit
            </button>
          </div>
        </div>
        <div className="row">
          <div
            className="col-xs-12 col-sm-12 col-md-12 col-lg-12 textcenter"
            style={{ width: "70%", marginTop: "10px" }}
          >
            {this.state.postresult}
          </div>
        </div>
        {this.state.mytoast.show ? MyToast(this.state.mytoast) : null}
      </div>
    );
  }
  back() {
    if (window.confirm("Do you need to save the form?")) {
      this.submit();
      window.history.back();
    } else window.history.back();
  }
  setCheck(ref, field) {
    let val = ref.target.value;

    /*     if (val == "") val = "N";
    if (val == "N") val = "Y";
    else val = "N";
 */
    if (field == "discussed")
      this.setState({
        discussed: val,
      });
    else if (field == "received") {
      this.setState({
        received: val,
      });
    }
  }
  changeField2(ref, index, field) {
    let val = "";
    if (ref.target.checked) {
      val = "Y";
    } else {
      val = "N";
    }

    if (field == "areas") {
      let areas = this.state.areas;
      areas[index].c = val;

      this.setState({
        areas: areas,
      });
    } else if (field == "acerstreated") {
      let acerstreated = this.state.acerstreated;
      acerstreated[index].c = val;

      this.setState({
        acerstreated: acerstreated,
      });
    } else if (field == "assessment") {
      this.setState({
        assessment: val,
      });
    } else if (field == "treatment") {
      this.setState({
        treatment: val,
      });
    }
  }
  changeField3(ref, index, field) {
    let val = ref.target.value;
    if (field == "areas") {
      let areas = this.state.areas;
      areas[index].a = val;

      this.setState({
        areas: areas,
      });
    } else if (field == "acerstreated") {
      let acerstreated = this.state.acerstreated;
      acerstreated[index].a = val;

      this.setState({
        acerstreated: acerstreated,
      });
    }
  }
  changeField(e, field) {
    let val = e.target.value;
    if (field == "limititation")
      this.setState({
        limititation: val,
      });
    else if (field == "goal") {
      this.setState({
        goal: val,
      });
    } else if (field == "focus")
      this.setState({
        focus: val,
      });
    else if (field == "frequency")
      this.setState({
        frequency: val,
      });
    else if (field == "duratiuon")
      this.setState({
        duratiuon: val,
      });
    else if (field == "schedule")
      this.setState({
        schedule: val,
      });
    else if (field == "result")
      this.setState({
        result: val,
      });
    else if (field == "recommended")
      this.setState({
        recommended: val,
      });
    else if (field == "schedule")
      this.setState({
        schedule: val,
      });
    else if (field == "referral")
      this.setState({
        referral: val,
      });
    else if (field == "contraindications")
      this.setState({
        contraindications: val,
      });
    else if (field == "performed")
      this.setState({
        performed: val,
      });
    else if (field == "antiresponse")
      this.setState({
        antiresponse: val,
      });
  }

  submit() {
    const { myusername, ukey } = this.props;
    // document.getElementById("result2").style.color = "#000000";

    this.setState({
      postresult: "Waiting....",
    });
    // document.getElementById("result2").innerHTML = "正在提交....";

    //var gzhnickname = this.state.upgzhnickname;
    //var comname = this.state.upcomname;

    const postdata = {
      editid: this.state.editid,
      bookid: this.state.bookid,

      limititation: this.state.limititation,
      goal: this.state.goal,
      focus: this.state.focus,
      areas: this.state.areas,
      discussed: this.state.discussed,
      received: this.state.received,
      frequency: this.state.frequency,
      duratiuon: this.state.duratiuon,
      schedule: this.state.duratiuon,
      performed: this.state.performed,
      result: this.state.result,
      referral: this.state.referral,
      antiresponse: this.state.antiresponse,
      recommended: this.state.recommended,
      contraindications: this.state.contraindications,
    };

    // return;
    const this2 = this;
    var error = "";

    // else if (clientsigndate == "") error = "Please fill in signature date";

    //document.getElementById("result2").style.color = "red";
    if (error !== "") {
      this.setState({
        postresult: error,
      });
    } else {
      $.ajax({
        type: "POST",
        dataType: "json",
        url:
          AJAROOT +
          "/postaja/savexx.aspx?action=savetreateplan&u=" +
          myusername +
          "&ukey=" +
          encodeURIComponent(ukey) +
          "",
        data: JSON.stringify(postdata),
      })
        .done(function (res) {
          console.log(res);
          var r = res.r;
          var msg = res.msg;

          if (r === "1") {
            //  this.postresult = "登陆成功！";

            this2.setState({
              postresult: "Successfully",
            });
            //if (myusername == this2.state.username)
            //this2.props.history.push("/user");
          } else {
            //document.getElementById("result2").style.color = "red";
            this2.setState({
              postresult: msg,
            });

            //  document.getElementById("result2").innerHTML = msg;
          }
        })
        .fail(function (xhr, textStatus, errorThrown) {
           this2.setState({
              postresult: "Failure",
            });

        });
    }
  }

  getData(myusername, ukey, bookid) {
    var geturl =
      AJAROOT +
      "/getaja/xx.aspx?u=" +
      myusername +
      "&bookid=" +
      bookid +
      "&ukey=" +
      encodeURIComponent(ukey) +
      "&action=treateplan";
    console.log(geturl);
    axios.get(geturl).then((res) => {
      const result = res.data;
      console.log(result);
      this.setState({
        editid: result.editid,
        customer: result.customer,

        periodno: result.periodno,
        fromtime: result.fromtime,
        totime: result.totime,
        minutes: result.minutes,
        price: result.price,
        employeename: result.employeename,

        limititation: result.limititation,
        goal: result.goal,
        areas: result.areas,
        focus: result.focus,

        discussed: result.discussed,
        received: result.received,
        frequency: result.frequency,
        duratiuon: result.duratiuon,
        performed: result.performed,
        schedule: result.schedule,
        result: result.result,
        referral: result.referral,
        antiresponse: result.antiresponse,
        recommended: result.recommended,
        contraindications: result.contraindications,
      });
    });
  }
  printPage(url) {
    var orihtml = window.document.body.innerHTML; //从标记里获取需要打印的页面
    //  document.getElementById("content").style.padding = "10px";
    var printHtml = document.getElementById("content").innerHTML; //从标记里获取需要打印的页面

    window.document.body.innerHTML = printHtml; //需要打印的页面

    window.print();
    window.document.body.innerHTML = orihtml;
    window.open(url, "_self");
  }
  print(url) {
    window.open(url, "_blank");
  }
  componentDidMount() {
    const { myusername, ukey } = this.props;
    //const { t } = this.props.match.params;
    var { bookid, print } = queryString.parse(this.props.location.search);
    var title = "Treatment Plan";
    document.title = title;
    if (bookid == null) bookid = "";
    if (print == null) print = "";
    if (print == "1") {
      this.setState({
        isprint: true,
      });
    }
    this.setState({
      title: title,
      bookid: bookid,
    });

    //  getUserIndexData(this, myusername, ukey);
    this.getData(myusername, ukey, bookid);
  }

  componentWillUnmount() {
    this.submit();
    this.setState = (state, callback) => {
      return;
    };
  }

  componentWillUpdate() {}
  componentDidUpdate() {}
}

const mapStateToProps = (state) => {
  return {
    myusername: state.getIn(["gdata", "username"]),
    myusertype: state.getIn(["gdata", "usertype"]),
    myusergrade: state.getIn(["gdata", "usergrade"]),
    ukey: state.getIn(["gdata", "ukey"]),
    cartnum: state.getIn(["gdata", "cartnum"]),
  };
};

export default connect(mapStateToProps, null)(User);
